import React, { Component } from 'react'
import Collapsible from '../Collapsible'
import CheckBox from '../../components/CheckBox'
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import enGB from "date-fns/locale/en-GB"
import "react-datepicker/dist/react-datepicker.css"


class FilterDate extends Component { 
  componentDidMount() {
    registerLocale("en-GB", enGB)
    setDefaultLocale(enGB)
  }

  dateChanged = (isChecked, selectedValue) => {   
    this.props.onDateRangeChanged(undefined, undefined)
  }

  handleFromDateChange = (dateIn) => { 
    this.props.onDateRangeChanged(dateIn === null ? undefined : dateIn, this.props.selectedDateTo)
  }

  handleToDateChange = (dateIn) => {          
    this.props.onDateRangeChanged(this.props.selectedDateFrom, dateIn === null ? undefined : dateIn)
  }

  render () {   

    const selectedDateFrom = this.props.selectedDateFrom !== '' ?  this.props.selectedDateFrom : undefined
    const selectedDateTo = this.props.selectedDateTo !== '' ?  this.props.selectedDateTo : undefined
       
    return (
      <div className='box-dateRange'>
        <Collapsible title='Date Range' titleClassName='box-header' id='dateRange' open>
          <div className='div-separator'>
            <CheckBox
              id='cbDateAll'
              Name='cbDateAll'
              Checked={selectedDateFrom === undefined && selectedDateTo === undefined}
              onTickChanged={(chk, val) => this.dateChanged(chk, val)}
              Value='0' text='Show All'
            />
          </div>
          <div className='datePicker'>
            <label>Date From (dd/mm/yyyy)</label>
            <DatePicker 
              id='datePickerFrom'
              selected={selectedDateFrom} 
              onChange={this.handleFromDateChange}           
              peekNextMonth={false}            
              showMonthDropdown
              showYearDropdown
              scrollableYearDropdown={false}
              locale="en-GB"
              dateFormat="dd/MM/yyyy"
              placeholderText="Select date"
              shouldCloseOnSelect={true}
              defaultValue={null}           
              />
          </div>        
          <div className='datePicker' style={{marginTop: "10px"}}>
            <label>Date To (dd/mm/yyyy)</label>
            <DatePicker 
              id='datePickerTo'
              selected={selectedDateTo} 
              onChange={this.handleToDateChange}           
              peekNextMonth={false}            
              showMonthDropdown
              showYearDropdown
              scrollableYearDropdown={false}
              locale="en-GB"
              dateFormat="dd/MM/yyyy"
              placeholderText="Select date"
              shouldCloseOnSelect={true}
              defaultValue={null}           
              />
          </div>  
          {this.props.selectedDateFrom > this.props.selectedDateTo ?   
          <div className='error-msg'>Error: The 'Date From' cannot be later than the 'Date To'</div>
          : null}

        </Collapsible>
      </div>
    )
  }
}
export default FilterDate